import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getUtmParamsForQrCodeUrl } from '../../helpers';
import { getAsset } from '../../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../../hooks/useComponentSize';
import { ALL_PHOTOS_MODE } from '../../../../../../../../../constants/album-folder';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
    all_photos_mode: PropTypes.string,
    joins_enabled: PropTypes.bool,
    public_join_code_verification_enabled: PropTypes.bool,
  }).isRequired,
};
const BusinessCardBack = ({ albumFolder, ...props }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const {
    all_photos_mode: allPhotosMode,
    is_web_gallery: isWebGallery,
    joins_enabled: joinsEnabled,
    join_code: joinCode,
    public_join_code_verification_enabled: joinCodeRequired,
  } = albumFolder;
  const isPublicAllPhotos = allPhotosMode === ALL_PHOTOS_MODE.PUBLIC;
  let url;

  if ((isWebGallery || isPublicAllPhotos) && !joinsEnabled) {
    url = albumFolder?.web_app_urls?.all_photos_access_url;
  } else {
    url = albumFolder?.onboarding_short_url;
  }
  const isFWGImageAsset =
    (isWebGallery || isPublicAllPhotos) &&
    !joinsEnabled &&
    joinCode &&
    joinCodeRequired;

  const imgAsset = isFWGImageAsset
    ? '/marketing-material/MARKETING_BUSINESS_CARD_FWG.png'
    : '/marketing-material/MARKETING_BUSINESS_CARD_GENERAL.png';

  const renderFRTextMessageSection = () => (
    <div className="marketing-material-business-card-back-join-code">
      <strong>or</strong>
      <br />
      Text the code:
      <br />
      <span className="text-uppercase text-extra-bold">
        {albumFolder.join_code}
      </span>
      <br />
      to 735343
    </div>
  );

  const renderFWGWithJCSection = () => (
    <div className="marketing-material-business-card-back-join-code fwg-card">
      <span className="text-uppercase text-extra-bold">{joinCode}</span>
    </div>
  );

  const renderJoinCodeSection = () => {
    const isWG = isWebGallery || isPublicAllPhotos;

    if (!joinCode) return null;

    if (isWG && !joinCodeRequired) {
      return null;
    }

    if (isFWGImageAsset) {
      return renderFWGWithJCSection();
    }

    return renderFRTextMessageSection();
  };

  return (
    <div
      className="marketing-material-business-card marketing-material-business-card-back"
      {...props}
    >
      {renderJoinCodeSection()}
      <div className="marketing-material-business-card-back-qr">
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.32 ?? 100}
        />
      </div>
      <img ref={templateRef} src={getAsset(imgAsset)} alt="" />
    </div>
  );
};

BusinessCardBack.propTypes = propTypes;

export default BusinessCardBack;
